import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chart-ring-1"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M16.8993 10.9977C17.4534 13.703 15.7095 16.3452 13.0043 16.8993C10.299 17.4534 7.65679 15.7095 7.10268 13.0043C6.54858 10.299 8.29243 7.65679 10.9977 7.10268C13.703 6.54858 16.3452 8.29243 16.8993 10.9977Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M9.99392 2.2041C4.5834 3.31231 1.09569 8.59679 2.2039 14.0073C3.31211 19.4178 8.59659 22.9055 14.0071 21.7973C18.1385 20.9511 21.1488 17.6699 21.8478 13.7569M14.0796 2.2168C17.8492 3.01983 20.9744 5.97705 21.7972 9.99429","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M16.8993 10.9977C17.4534 13.703 15.7095 16.3452 13.0043 16.8993C10.299 17.4534 7.65679 15.7095 7.10268 13.0043C6.54858 10.299 8.29243 7.65679 10.9977 7.10268C13.703 6.54858 16.3452 8.29243 16.8993 10.9977Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChartRing1 = Vue.extend<IconProps>({
  name: 'ChartRing1Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'chart-ring-1',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ChartRing1;
